/**
 * 生成专题图功能
 */
import { fromLonLat} from 'ol/proj'
import { Tile, Group, Image, Vector as lVector } from 'ol/layer'
import { XYZ, OSM, Vector, ImageArcGISRest,TileArcGISRest, TileWMS, Cluster,ImageWMS } from 'ol/source'
import { GeoJSON, WFS, WMSCapabilities,WMTSCapabilities,WMSGetFeatureInfo } from 'ol/format'
import { Style, Fill, Stroke, Circle, Text, Circle as CircleStyle, Icon } from 'ol/style'
import { equalTo, greaterThan, bbox } from 'ol/format/filter'
import { ScaleLine } from 'ol/control'
import ol_ext_element from 'ol-ext/util/element'
export const AutoThematicMap = {
  data(){
    return {
      imageType: {},
      width:0,
      height: 0,
      dpr: window.devicePixelRatio
    }
  },
  methods: {
    js_getDPI() {
      var arrDPI = new Array();
      if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
      }
      else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";//1in是1英尺
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
      }
      return arrDPI;
    },
    createThematicMap(option) {
      let that=this;
      that.nameTitle = '北京市';
      setTimeout(()=>{
        //控制地图缩放等级
        that.map.getView().setZoom(that.map.getView().getZoom()-0.1)
          var scale1;
          if(that.nameTitle === '北京市'){
          scale1 = that.map.getView().values_.resolution* 65.41332273339661*3/4;
          }else if(that.nameTitle === '全国'){
            scale1 = 400000;
          }
          var danwei = 'm';
          if(scale1 >= 1000){
            danwei = 'km';
            scale1 = (scale1/1000).toFixed(0);
          }
        var scale2 = 2*scale1;
        this.printControl.__proto__.print = function(options) {
          options = options || {};
          var imageType = options.imageType || this.get('imageType');
          var quality = options.quality || this.get('quality');
          if (this.getMap()) {
            if (options.immediate !== 'silent') {
              this.dispatchEvent(Object.assign({ 
                type: 'printing',
              }, options));
            }
            // Start printing after delay to let user show info in the DOM
            if (!options.immediate) {
              setTimeout (function () {
                options = Object.assign({}, options);
                options.immediate = 'silent';
                this.print(options);
              }.bind(this), 200);
              return;
            }
            // Run printing
            this.getMap().once('rendercomplete', function(event) {
              var canvas, ctx;
              // ol <= 5 : get the canvas
              if (event.context) {
                canvas = event.context.canvas;
              } else {
                // ol6+ : create canvas using layer canvas
                this.getMap().getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-fixedoverlay').forEach(function(c) {
                  if (c.width) {
                    // Create a canvas if none
                    if (!canvas) {
                      canvas = document.createElement('canvas');
                      var size = this.getMap().getSize();
                      canvas.width = size[0];
                      canvas.height = size[1];
                      ctx = canvas.getContext('2d');
                      if (/jp.*g$/.test(imageType)) {
                        ctx.fillStyle = this.get('bgColor') || 'white';
                        ctx.fillRect(0,0,canvas.width,canvas.height);	
                      }
                    }
                    ctx.save();
                    // opacity
                    if (c.parentNode.style.opacity==='0') return;
                    ctx.globalAlpha = parseFloat(c.parentNode.style.opacity) || 1;
                    // transform
                    var tr = ol_ext_element.getStyle(c,'transform') || ol_ext_element.getStyle(c,'-webkit-transform');
                    if (/^matrix/.test(tr)) {
                      tr = tr.replace(/^matrix\(|\)$/g,'').split(',');
                      tr.forEach(function(t,i) { tr[i] = parseFloat(t); });
                      ctx.transform(tr[0],tr[1],tr[2],tr[3],tr[4],tr[5]);
                      ctx.drawImage(c, 0, 0);
                    } else {
                      ctx.drawImage(c, 0, 0, ol_ext_element.getStyle(c,'width'), ol_ext_element.getStyle(c,'height'));
                    }
                    ctx.restore();
                  }
                }.bind(this));
              }
              // Calculate print format
              var size = [210,297], format = 'a4';
              var w, h, position;
              var orient = options.orient || this.get('orientation');
              var margin = options.margin || 10;
              if (canvas) {
                // Calculate size
                if (orient!=='landscape' && orient!=='portrait') {
                  orient = (canvas.width > canvas.height) ? 'landscape' : 'portrait';
                }
                if (orient === 'landscape') size = [size[1],size[0]];
                var sc = Math.min ((size[0]-2*margin)/canvas.width,(size[1]-2*margin)/canvas.height);
                w = sc * canvas.width;
                h = sc * canvas.height;
                // Image position
                position = [(size[0] - w)/2, (size[1] - h)/2];
              }
              // get the canvas image
              var image;
              var date = new Date();
              try { 
                ctx = canvas.getContext('2d');
                //上下左右的空白条
                /* ctx.fillStyle = "rgba(255,255,255,1)";
                ctx.fillRect(0,0,canvas.width,30); */

                //设置四个角的空白条  防止多余的经纬度显示
                /* ctx.fillStyle = "rgba(255,255,255,1)";
                ctx.fillRect(0,0,118,52);

                ctx.fillStyle = "rgba(255,255,255,1)";
                ctx.fillRect(canvas.width-118,0,118,52);

                ctx.fillStyle = "rgba(255,255,255,1)";
                ctx.fillRect(0,canvas.height-52,118,52);

                ctx.fillStyle = "rgba(255,255,255,1)";
                ctx.fillRect(canvas.width-118,canvas.height-52,118,52);
 */ 
                /* //外边边框
                ctx.beginPath();
                ctx.lineWidth="3";
                ctx.strokeStyle="black";
                ctx.rect(468,40,canvas.width-936,canvas.height-80);
                ctx.stroke();

                //上面的标题和制作日期
                ctx.font="bold 30px Arial";
                ctx.fillStyle="black";
                ctx.textAlign="center";
                ctx.textBaseline="middle";
                ctx.fillText(`北京市森林火险辅助决策意见(${(date.getMonth()+1)}月${date.getDate()}日${date.getHours()}时)`,canvas.width/2,18);

                ctx.fillStyle = "#FFFF00";
                ctx.fillRect(canvas.width-653,canvas.height-162,60,30);
                ctx.font="20px arial,sans-serif";
                ctx.fillStyle="black";
                ctx.textAlign="left";
                ctx.fillText(`中度危险`,canvas.width-583,canvas.height-147);

                ctx.fillStyle = "#FFC000";
                ctx.fillRect(canvas.width-653,canvas.height-122,60,30);
                ctx.font="20px arial,sans-serif";
                ctx.fillStyle="black";
                ctx.textAlign="left";
                ctx.fillText(`高度危险`,canvas.width-583,canvas.height-107);

                ctx.fillStyle = "#FF0000";
                ctx.fillRect(canvas.width-653,canvas.height-82,60,30);
                ctx.font="20px arial,sans-serif";
                ctx.fillStyle="black";
                ctx.textAlign="left";
                ctx.fillText(`极度危险`,canvas.width-583,canvas.height-67);

                //图例文字
                ctx.font="bold 25px Arial";
                ctx.fillStyle="black";
                ctx.textAlign="center";
                ctx.textBaseline="middle";
                ctx.fillText(`图例`,canvas.width-582,canvas.height-192);

                //指南针
                var zhinanzhen=document.getElementById("zhinanzhen");
                ctx.drawImage(zhinanzhen,488,60,60,80);

                //左下角发布日期
                ctx.font="bold 25px Arial";
                ctx.fillStyle="black";
                ctx.textAlign="left";
                ctx.textBaseline="middle";
                ctx.fillText(`${(date.getMonth()+1)}月${date.getDate()}日${date.getHours()}时发布`,488,canvas.height-65);

                 //比例尺  120对应15km   160对应20km
                ctx.beginPath();
                ctx.fillStyle="black";
                ctx.lineWidth=15;
                ctx.moveTo(canvas.width-938,canvas.height-65);
                ctx.lineTo(canvas.width-818,canvas.height-65);
                ctx.strokeStyle="black";
                ctx.stroke();
                //比例尺的值
                ctx.textAlign="left";
                ctx.font="bold 20px Arial";
                ctx.fillText(`0`,canvas.width-938,canvas.height-85);

                ctx.beginPath();
                ctx.lineWidth=11;
                ctx.moveTo(canvas.width-818,canvas.height-65);
                ctx.lineTo(canvas.width-698,canvas.height-65);
                ctx.strokeStyle="white";
                ctx.stroke();
                //白边的边框
                ctx.beginPath();
                ctx.lineWidth="2";
                ctx.strokeStyle="black";
                ctx.rect(canvas.width-818,canvas.height-71.5,120,13);
                ctx.stroke();
                //比例尺的值
                ctx.textAlign="center";
                ctx.font="bold 20px Arial";
                ctx.fillText(`${scale1}`,canvas.width-821,canvas.height-85);

                //比例尺的值
                ctx.textAlign="center";
                ctx.font="bold 20px Arial";
                ctx.fillText(`${scale2}`,canvas.width-701,canvas.height-85);

                //单位都设定为m
                ctx.textAlign="left";
                ctx.font="bold 20px Arial";
                ctx.fillText(`${danwei}`,canvas.width-690,canvas.height-67);
 */
                //外边边框
                ctx.beginPath();
                ctx.lineWidth="2";
                ctx.strokeStyle="black";
                ctx.rect(468*canvas.width/1896,40,canvas.width-936*canvas.width/1896,canvas.height-60*canvas.height/890);
                ctx.stroke();
                //console.log(468*canvas.width/1896)

                //上面的标题和制作日期
                ctx.font="bold 25px Arial";
                ctx.fillStyle="black";
                ctx.textAlign="center";
                ctx.textBaseline="middle";
                // ctx.fillText(`${that.nameTitle}森林火险辅助决策意见(${that.zhuantituShowDateTime[1]}月${that.zhuantituShowDateTime[2]}日0-24时)`,canvas.width/2,20);
                ctx.fillText(`这是title`,canvas.width/2,20);

                
                //指南针
                var zhinanzhen=document.getElementById("zhinanzhen");
                ctx.drawImage(zhinanzhen,488*canvas.width/1896,60,100*canvas.width/1896,100*canvas.height/890);

                //北京市矢量
                /* var beijingshiresult=document.getElementById("beijingshiresult");
                ctx.drawImage(beijingshiresult,468*canvas.width/1896,40,canvas.width-936*canvas.width/1896,canvas.height-60*canvas.height/890); */

                //公司logo
                //var gongsi=document.getElementById("gongsi");
                //ctx.drawImage(gongsi,480*canvas.width/1896,canvas.height-55*canvas.height/890,210*canvas.width/1896,28*canvas.height/890);

                
                 //比例尺  120对应15km   160对应20km
                ctx.beginPath();
                ctx.fillStyle="black";
                ctx.lineWidth=15*canvas.height/890;
                ctx.moveTo(canvas.width-938*canvas.width/1896,canvas.height-55*canvas.height/890);
                ctx.lineTo(canvas.width-818*canvas.width/1896,canvas.height-55*canvas.height/890);
                ctx.strokeStyle="black";
                ctx.stroke();
                //比例尺的值
                ctx.textAlign="left";
                ctx.font="bold 18px Arial";
                ctx.fillText(`0`,canvas.width-938*canvas.width/1896,canvas.height-75*canvas.height/890);

                ctx.beginPath();
                ctx.lineWidth=11*canvas.height/890;
                ctx.moveTo(canvas.width-818*canvas.width/1896,canvas.height-55*canvas.height/890);
                ctx.lineTo(canvas.width-698*canvas.width/1896,canvas.height-55*canvas.height/890);
                ctx.strokeStyle="white";
                ctx.stroke();
                //白边的边框
                ctx.beginPath();
                ctx.lineWidth=2*canvas.height/890;
                ctx.strokeStyle="black";
                ctx.rect(canvas.width-818*canvas.width/1896,canvas.height-61.5*canvas.height/890,120*canvas.width/1896,13*canvas.height/890);
                ctx.stroke();
                //比例尺的值
                ctx.textAlign="center";
                ctx.font="bold 18px Arial";
                ctx.fillText(`${scale1}`,canvas.width-821*canvas.width/1896,canvas.height-75*canvas.height/890);

                //比例尺的值
                ctx.textAlign="center";
                ctx.font="bold 18px Arial";
                ctx.fillText(`${scale2}`,canvas.width-701*canvas.width/1896,canvas.height-75*canvas.height/890);

                //单位都设定为m
                ctx.textAlign="left";
                ctx.font="bold 18px Arial";
                ctx.fillText(`${danwei}`,canvas.width-690*canvas.width/1896,canvas.height-57*canvas.height/890);

                ctx.save();
                image = canvas ? canvas.toDataURL(imageType, quality) : null;
                
              } catch(e) {
                console.log(e)
                // Fire error event
                this.dispatchEvent({
                  type: 'error',
                  canvas: canvas
                });
                return;
              }
              // Fire print event
              
              var e = Object.assign({ 
                type: 'print',
                print: {
                  format: format,
                  orientation: orient,
                  unit: 'mm',
                  size: size,
                  position: position,
                  imageWidth: w,
                  imageHeight: h
                },
                image: image,
                imageType: imageType,
                canvas: canvas
              }, options);
              this.dispatchEvent(e);
            }.bind(this));
            this.getMap().render();
          }
        };
        /* html2canvas(document.querySelector('.ol-unselectable'),{useCORS:true}).then(function(canvas) {
             // document.body.appendChild(canvas);
             let img=canvas.toDataURL('image/jpg');
             console.log(img);
             document.querySelector('#image img').setAttribute('src',img);
        }); */

        this.printControl.print(option);
        //}

      },2000)

    },
    PrintStroke(cutPicPanelVisible) {//画外边边框，有问题，没和A4对上
      //获取DPI
      
      function get_dpi() {
        for (var i = 56; i < 2000; i++) {
          if (matchMedia("(max-resolution: " + i + "dpi)").matches === true) {
            return i;
          }
        }
      }
      let a = this.js_getDPI()
      let dpi = a[0];//分辨率的度量单位，指每一英寸长度中，取样、可显示或输出点的数目。
      // let dpi = get_dpi()
      // 实际尺寸(英寸)=像素/分辨率; 1英寸=2.54厘米;
      let height = 21 * dpi / 2.54
      let width = 29.7 * dpi / 2.54
      // let width = 28.5 * dpi /2.54

      // var sc = Math.min((width - 2 * 10) / width, (height - 2 * 10) / height);
      // let w = sc * width;
      // let h = sc * height;
      this.width = width;
      this.height = height;
      // debugger

      let redRectCanvas = document.querySelector('#redRectCanvas')
      let newCanvas = document.querySelector('#newCanvas')
      if (cutPicPanelVisible) {
        let canvas = document.createElement('canvas');
        canvas.width = this.width
        canvas.height = this.height
        // canvas.style.width = this.width+'px'
        // canvas.style.height = this.height + 'px'
        let ctx = canvas.getContext('2d');
        ctx.lineWidth = "1";
        ctx.strokeStyle = "rgba(255,0,0,1)";
        ctx.rect(1, 1, this.width-2, this.height-2);
        ctx.stroke();

        ctx.beginPath();
        ctx.lineWidth = "1";
        ctx.strokeStyle = "rgba(255,255,255,1)";
        ctx.rect(30, 80, this.width - 60, this.height - 128);
        ctx.stroke();

        redRectCanvas.appendChild(canvas)
      } else {
        redRectCanvas.innerHTML=''
        newCanvas.innerHTML=''
      }
    },
    Print(option) {
      let that = this;
      // if (!that.cutImgTitle) {
      //   that.$message.warning('请先输入标题！');
      //   return;
      // }
      this.printControl.__proto__.print = function (options) {
        options = options || {};
        var imageType = options.imageType || this.get('imageType');
        var quality = options.quality || this.get('quality');
        if (this.getMap()) {
          if (options.immediate !== 'silent') {
            this.dispatchEvent(Object.assign({
              type: 'printing',
            }, options));
          }
          // Start printing after delay to let user show info in the DOM
          if (!options.immediate) {
            setTimeout(function () {
              options = Object.assign({}, options);
              options.immediate = 'silent';
              this.print(options);
            }.bind(this), 200);
            return;
          }
          // Run printing
          this.getMap().once('rendercomplete', function (event) {
            var canvas, ctx, ctxA4, resultCanvas;
            // ol <= 5 : get the canvas
            if (event.context) {
              canvas = event.context.canvas;
              ctx = canvas.getContext('2d');
              // let leftTop=that.map.getCoordinateFromPixel([0,0])
              // let rightBottom = that.map.getCoordinateFromPixel([that.width, that.height])
              // let leftTopPixel =that.map.getPixelFromCoordinate(leftTop)
              // let rightBottomPixel = that.map.getPixelFromCoordinate(rightBottom)
              // debugger
              let canvasData = ctx.getImageData(0, 0, that.width * that.dpr, that.height * that.dpr);  // 获取画布

              resultCanvas = document.createElement('canvas');
              resultCanvas.id = 'printCanvas'
              resultCanvas.width = that.width * that.dpr
              resultCanvas.height = that.height * that.dpr
              let newCanvas = document.querySelector('#newCanvas')
              newCanvas.appendChild(resultCanvas)

              ctxA4 = resultCanvas.getContext('2d')
              ctxA4.putImageData(canvasData, 0, 0);
            } else {
              // ol6+ : create canvas using layer canvas
              this.getMap().getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-fixedoverlay').forEach(function (c) {
                if (c.width) {
                  // Create a canvas if none
                  if (!canvas) {
                    canvas = document.createElement('canvas');
                    var size = this.getMap().getSize();
                    canvas.width = size[0];
                    canvas.height = size[1];
                    ctx = canvas.getContext('2d');
                    if (/jp.*g$/.test(imageType)) {
                      ctx.fillStyle = this.get('bgColor') || 'white';
                      ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                  }
                  ctx.save();
                  // opacity
                  if (c.parentNode.style.opacity === '0') return;
                  ctx.globalAlpha = parseFloat(c.parentNode.style.opacity) || 1;
                  // transform
                  var tr = ol_ext_element.getStyle(c, 'transform') || ol_ext_element.getStyle(c, '-webkit-transform');
                  if (/^matrix/.test(tr)) {
                    tr = tr.replace(/^matrix\(|\)$/g, '').split(',');
                    tr.forEach(function (t, i) { tr[i] = parseFloat(t); });
                    ctx.transform(tr[0], tr[1], tr[2], tr[3], tr[4], tr[5]);
                    ctx.drawImage(c, 0, 0);
                  } else {
                    ctx.drawImage(c, 0, 0, ol_ext_element.getStyle(c, 'width'), ol_ext_element.getStyle(c, 'height'));
                  }
                  ctx.restore();
                }
              }.bind(this));
            }
            // Calculate print format
            var size = [210, 297], format = 'a4';
            var w, h, position;
            var orient = options.orient || this.get('orientation');
            var margin = options.margin || 10;
            if (canvas) {
              // Calculate size
              if (orient !== 'landscape' && orient !== 'portrait') {
                orient = (that.width > that.height) ? 'landscape' : 'portrait';
              }
              if (orient === 'landscape') size = [size[1], size[0]];
              // var sc = Math.min((size[0] - 2 * margin) / that.width, (size[1] - 2 * margin) / that.height);
              // w = sc * that.width;
              // h = sc * that.height;
              w = that.width;
              h = that.height;
              // Image position
              position = [(size[0] - w) / 2, (size[1] - h) / 2];
            }
            // debugger
            // get the canvas image
            var image;
            try {
              let scaleLine, scaleLineWidth;
              that.map.getControls().forEach(c => {
                if (c instanceof ScaleLine) {
                  scaleLine = c.renderedHTML_;
                  scaleLine = scaleLine.split(' ');
                  scaleLineWidth = c.renderedWidth_;
                  //用于设置当前缩放级别下1cm表示的比例尺
                  // let dpi=that.js_getDPI()[0]
                  // let cmNumber = scaleLineWidth / dpi * 2.54;//实际多少厘米
                  // scaleLine[0] = Number(scaleLine[0]) / cmNumber;
                  // scaleLineWidth = scaleLineWidth / cmNumber;
                  // debugger
                  // if (scaleLine[1]=='km') {
                  //   scaleLine[0] = Math.round(scaleLine[0] * 1000)
                  //   scaleLine[1] ='m'
                  // }
                  // if (scaleLine[1]=='m') {
                  //   scaleLine[0] = Math.round(scaleLine[0])
                  // }
                }
              })
              
              image = canvas ? canvas.toDataURL(imageType, quality) : null;
            } catch (e) {
              // Fire error event
              console.error(e)
              this.dispatchEvent({
                type: 'error',
                canvas: canvas
              });
              return;
            }
            // Fire print event
            var e = Object.assign({
              type: 'print',
              print: {
                format: format,
                orientation: orient,
                unit: 'mm',
                size: size,
                position: position,
                imageWidth: w,
                imageHeight: h
              },
              image: image,
              imageType: imageType,
              canvas: canvas
            }, options);
            this.dispatchEvent(e);
          }.bind(this));
          this.getMap().render();
        }
      };
      this.printControl.print(option);
    },
    Print_old(option) {
      let that = this;
      if (!that.cutImgTitle) {
        that.$message.warning('请先输入标题！');
        return;
      }
      this.printControl.__proto__.print = function (options) {
        options = options || {};
        var imageType = options.imageType || this.get('imageType');
        var quality = options.quality || this.get('quality');
        if (this.getMap()) {
          if (options.immediate !== 'silent') {
            this.dispatchEvent(Object.assign({
              type: 'printing',
            }, options));
          }
          // Start printing after delay to let user show info in the DOM
          if (!options.immediate) {
            setTimeout(function () {
              options = Object.assign({}, options);
              options.immediate = 'silent';
              this.print(options);
            }.bind(this), 200);
            return;
          }
          // Run printing
          this.getMap().once('rendercomplete', function (event) {
            var canvas, ctx;
            // ol <= 5 : get the canvas
            if (event.context) {
              canvas = event.context.canvas;
            } else {
              // ol6+ : create canvas using layer canvas
              this.getMap().getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-fixedoverlay').forEach(function (c) {
                if (c.width) {
                  // Create a canvas if none
                  if (!canvas) {
                    canvas = document.createElement('canvas');
                    var size = this.getMap().getSize();
                    canvas.width = size[0];
                    canvas.height = size[1];
                    ctx = canvas.getContext('2d');
                    if (/jp.*g$/.test(imageType)) {
                      ctx.fillStyle = this.get('bgColor') || 'white';
                      ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                  }
                  ctx.save();
                  // opacity
                  if (c.parentNode.style.opacity === '0') return;
                  ctx.globalAlpha = parseFloat(c.parentNode.style.opacity) || 1;
                  // transform
                  var tr = ol_ext_element.getStyle(c, 'transform') || ol_ext_element.getStyle(c, '-webkit-transform');
                  if (/^matrix/.test(tr)) {
                    tr = tr.replace(/^matrix\(|\)$/g, '').split(',');
                    tr.forEach(function (t, i) { tr[i] = parseFloat(t); });
                    ctx.transform(tr[0], tr[1], tr[2], tr[3], tr[4], tr[5]);
                    ctx.drawImage(c, 0, 0);
                  } else {
                    ctx.drawImage(c, 0, 0, ol_ext_element.getStyle(c, 'width'), ol_ext_element.getStyle(c, 'height'));
                  }
                  ctx.restore();
                }
              }.bind(this));
            }
            // Calculate print format
            var size = [210, 297], format = 'a4';
            var w, h, position;
            var orient = options.orient || this.get('orientation');
            var margin = options.margin || 10;
            if (canvas) {
              // Calculate size
              if (orient !== 'landscape' && orient !== 'portrait') {
                orient = (canvas.width > canvas.height) ? 'landscape' : 'portrait';
              }
              if (orient === 'landscape') size = [size[1], size[0]];
              var sc = Math.min((size[0] - 2 * margin) / canvas.width, (size[1] - 2 * margin) / canvas.height);
              w = sc * canvas.width;
              h = sc * canvas.height;
              // Image position
              position = [(size[0] - w) / 2, (size[1] - h) / 2];
            }
            // get the canvas image
            var image;
            try {
              let scaleLine, scaleLineWidth;
              that.map.getControls().forEach(c => {
                if (c instanceof ScaleLine) {
                  scaleLine = c.renderedHTML_;
                  scaleLineWidth = c.renderedWidth_;
                }
              })
              scaleLine = scaleLine.split(' ');
              ctx = canvas.getContext('2d');
              //上下左右的白边
              ctx.fillStyle = "rgba(255,255,255,1)";
              ctx.fillRect(0, 0, canvas.width, 80);
              ctx.fillRect(0, canvas.height - 40, canvas.width, 40);
              ctx.fillRect(0, 0, 30, canvas.height);
              ctx.fillRect(canvas.width - 30, 0, 30, canvas.height);
              //外边边框
              ctx.beginPath();
              ctx.lineWidth = "1";
              ctx.strokeStyle = "rgba(0,0,0,1)";
              ctx.rect(30, 80, canvas.width - 60, canvas.height - 120);
              ctx.stroke();

              //比例尺
              //左侧比例尺黑色区域
              ctx.fillStyle = "rgba(0,0,0,1)";
              ctx.fillRect(30, canvas.height - 15, scaleLineWidth, 10);
              //右侧比例尺的边框
              ctx.beginPath();
              ctx.lineWidth = "1";
              ctx.strokeStyle = "rgba(0,0,0,1)";
              ctx.rect(30 + scaleLineWidth, canvas.height - 14, scaleLineWidth, 8);
              ctx.stroke();
              //比例尺的值
              ctx.textAlign = "center";
              ctx.font = "bold 15px Arial";
              ctx.fillText(`0`, 30, canvas.height - 20);
              //比例尺的值
              ctx.textAlign = "center";
              ctx.font = "bold 15px Arial";
              ctx.fillText(scaleLine[0], 30 + scaleLineWidth, canvas.height - 20);
              //比例尺的值
              ctx.textAlign = "center";
              ctx.font = "bold 15px Arial";
              ctx.fillText(scaleLine[0] * 2, 30 + scaleLineWidth * 2, canvas.height - 20);
              //单位
              ctx.textAlign = "left";
              ctx.font = "bold 15px Arial";
              ctx.fillText(scaleLine[1], 30 + scaleLineWidth * 2 + 5, canvas.height - 5);

              //标题
              ctx.font = "bold 50px Arial";
              ctx.fillStyle = "#000000";
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";
              ctx.fillText(`${that.cutImgTitle}`, canvas.width / 2, 50);
             
              //指南针
              //白色背景
              ctx.fillStyle = "rgba(255,255,255,1)";
              ctx.fillRect(canvas.width - 70, 80, 40, 80);
              let zhinanzhen = document.getElementById("zhinanzhen");
              ctx.drawImage(zhinanzhen, canvas.width - 90, 80, 80, 80);
              
              //图例
              let legend_tables = document.querySelectorAll('#legend .rbody .legend_table');
              let legends = [];
              let maxFontCount = 0;
              legend_tables.forEach(t => {
                let perRow = t.querySelector('.perRow');
                let fontCount = perRow.children[1].innerText.length;
                maxFontCount = Math.max(fontCount, maxFontCount);
                legends.push({img:perRow.querySelector('img'),label:perRow.children[1].innerText})
              })
              //每一个图层的图例让它高30px，宽的话找字最多的那个计算
              let legendWidth = 30 + maxFontCount * 20 + 20;//50是预留给图例标题的
              let legendHeight = legends.length * 30 + 50;//50是预留给图例标题的
              
              //白色背景
              ctx.fillStyle = "rgba(255,255,255,1)";
              ctx.fillRect(canvas.width - legendWidth - 40, canvas.height - legendHeight - 40, legendWidth + 10, legendHeight + 10);
              //图例标题
              ctx.font = "25px Arial";
              ctx.textAlign = "start";
              ctx.fillStyle = "#000000";
              ctx.fillText(`图 例`, canvas.width - legendWidth - 30, canvas.height - legendHeight - 20);
              
              ctx.font = "20px Arial";
              ctx.textAlign = "start";
              legends.forEach((l, index) => {
                ctx.drawImage(l.img, canvas.width - legendWidth - 30, canvas.height - 40 - 30 * (legends.length-index), 20, 20);
                ctx.fillText(l.label, canvas.width - legendWidth , canvas.height - 30 - 30 * (legends.length - index));
              })

              ctx.save();

              image = canvas ? canvas.toDataURL(imageType, quality) : null;
            } catch (e) {
              // Fire error event
              console.error(e)
              this.dispatchEvent({
                type: 'error',
                canvas: canvas
              });
              return;
            }
            // Fire print event
            var e = Object.assign({
              type: 'print',
              print: {
                format: format,
                orientation: orient,
                unit: 'mm',
                size: size,
                position: position,
                imageWidth: w,
                imageHeight: h
              },
              image: image,
              imageType: imageType,
              canvas: canvas
            }, options);
            this.dispatchEvent(e);
          }.bind(this));
          this.getMap().render();
        }
      };
      this.printControl.print(option);
    },
  }
}